import React, { useMemo } from "react";
import { Input } from "@/components/ui/input";

/**
 * Lightweight comma-separated tag input. Stores an array externally.
 * The user types comma- or newline-separated tokens; we display the
 * normalised joined string.
 */
export function TagInput({
  value = [],
  onChange,
  placeholder,
  testId,
  separator = ",",
}) {
  const text = useMemo(() => (Array.isArray(value) ? value.join(`${separator} `) : ""), [value, separator]);

  const parse = (raw) =>
    raw
      .split(/[,\n]/)
      .map((s) => s.trim())
      .filter(Boolean);

  return (
    <Input
      type="text"
      value={text}
      placeholder={placeholder}
      data-testid={testId}
      onChange={(e) => onChange(parse(e.target.value))}
      className="h-11"
    />
  );
}
